/**
 * Copyright (c) 2020
 *
 * @summary calls to dataReport/localVisibility API
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-11-17 10:21:56
 * Last modified  : 2020-11-17 15:31:17
 */

import axios from '@/api/axios.js'

export default {

    /**
     * @param projectId int
     * @returns Promise
     */
    readAverageNote (projectId) {
        return axios.get(`/report/data/projects/${projectId}/local-visibility/average-note`)
    },


    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readCompetitor (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/local-visibility/competitor`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readKeywordsPositions (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/local-visibility/keywords-positions`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readLocalAdvertisingPresence (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/local-visibility/local-advertising-presence`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readMyBusinessKeywordsPositions (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/local-visibility/my-business-positions`,filters)
    },
};
